<template>
  <div class="products-grid-container">
    <ProductCardContainer
      v-for="(product, index) in products"
      :key="product.id"
      :product="product"
      :product-index="index"
      :entity-type="entityType"
    />
  </div>
</template>

<script>
import ProductCardContainer from './ProductCardContainer.vue'

export default {
  name: 'ProductsGrid',
  components: {
    ProductCardContainer
  },
  props: {
    /**
     * Page entity type
     */
    entityType: {
      type: String,
      required: true
    },
    /**
     * Products attributes
     */
    products: {
      type: Array,
      required: true
    }
  }
}
</script>
<style lang="scss" scoped>
.products-grid-container {
  --row-gap: 64px;
  --column-gap: 16px;
  --num-columns: 2;

  display: grid;
  grid-template-columns: repeat(var(--num-columns), minmax(0, 1fr));
  gap: var(--row-gap) var(--column-gap);

  @include tablet {
    --column-gap: 24px;
  }

  @include desktop {
    --num-columns: 3;
  }

  @include widescreen {
    --num-columns: 4;
  }
}
</style>
